<div class="card flex flex-col flex-1 gap-medpace">
    <div class="flex flex-row justify-end">
        <mds-text-field
            [label]="'Search'"
            [placeholder]="'Type here...'"
            [appearance]="'outline'"
            [startIcon]="'search'"
            [formCtrl]="searchControl"
        />
    </div>
    <mds-ag-grid
        class="flex-1"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        [columnDefs]="colDefs"
        [tableHeight]="'100%'"
        (gridReady)="gridApi.set($event.api)"
        (rowClicked)="rowClick($event)"
    />
</div>
